import "./Prices.module.css";
import Header from "@/reusable_sections/Header";
import ScheduleYourFreeDemo from "./sections/ScheduleYourFreeDemo";
import FlexibleHiringPackages from "./sections/FlexibleHiringPackages";
import LizingaVeidi from "./sections/LizingaVeidi";
import InquiryForm from "./sections/InquiryForm";
import Aboutxoraautomation from "./sections/Aboutxoraautomation";
import Footer from "@/reusable_sections/Footer";
export default function PricesPage() {
  return <div>
      <Header />
      <ScheduleYourFreeDemo />
      <FlexibleHiringPackages />
      <LizingaVeidi />
      <InquiryForm />
      <Aboutxoraautomation />
      <Footer />
    </div>;
}